import React, { useContext } from "react";
import Styles from "./index.module.scss";
import CourseButton from "../../../components/CourseComponents/CourseButton";
import { Spin } from "antd";
import useModalHandler from "../../../utils/v3/useModalHandler";
import EditQuestionModal from "./Components/EditQuestionModal";
import useRequest from "../../../utils/useRequest";
import { getQuestionnaireList } from "../../../service/question";
import { CourseContext } from "../Store";
import ListItem from "./Components/ListItem";
import CustomEmpty from "../../../components/CourseComponents/CustomEmpty";

const Index = () => {
    const { basename, course } = useContext(CourseContext);
    const weekTimeId = course.weekTimeId;

    const [data, { loading }, reload] = useRequest(
        () => getQuestionnaireList(weekTimeId),
        {},
        [weekTimeId]
    );

    function onEditSuccess() {
        reload();
        editModal.close();
    }

    //编辑
    const editModal = useModalHandler({
        component: EditQuestionModal
    });
    function openEditModal(id?: number | null) {
        editModal.open({
            id,
            type: "add",
            onSuccess: onEditSuccess
        });
    }

    return (
        <div className={Styles.root}>
            <div className={Styles.header}>
                <div className={Styles.count}>问卷活动（{data?.length}）</div>

                <CourseButton
                    type="add"
                    className={Styles.btn}
                    onClick={() => openEditModal(null)}>
                    添加
                </CourseButton>
            </div>
            <div>
                <Spin spinning={loading}>
                    {data?.map(item => (
                        <ListItem
                            key={item.id}
                            item={item}
                            updateList={reload}
                            onSetting={openEditModal}
                        />
                    ))}
                    {data && data.length < 1 && (
                        <CustomEmpty style={{ padding: "100px 0" }} />
                    )}
                </Spin>
            </div>

            {editModal.render()}
        </div>
    );
};

export default Index;
